import React from "react";
import {BrowserRouter} from "react-router-dom";
import "./App.scss";
import Main from "./containers/Main";
import {AuthProvider} from "./contexts/AuthContext";
import {SettingsProvider} from "./contexts/SettingsContext";

function App() {
  return (
    <BrowserRouter>
      <AuthProvider>
        <SettingsProvider>
          <div>
            <Main />
          </div>
        </SettingsProvider>
      </AuthProvider>
    </BrowserRouter>
  );
}

export default App;
